import React, { Component } from 'react';
import { request } from "../../util/APIUtils";
import { showAxiosError } from "../../util/Helpers";
import { notification } from "antd";
import LoadingIndicator from "../../common/LoadingIndicator";
import { API_BASE_URL } from "../../constants";

class TalepDeleteModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleDelete(id) {
        const token = localStorage.getItem("accessToken");
        const url = API_BASE_URL + "/nobettalep/" + id;

        const params = {
            url: url,
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + token,
            },
        };

        this.setState({ isLoading: true }); // Silme işlemi başladığında yükleniyor durumunu ayarla

        request(params)
            .then(() => {
                // Silme işlemi başarılı olduğunda
                notification.success({
                    message: 'ŞanlıUrfa Eczacı Odası',
                    description: this.props.selectedRequest.description + " Silindi",
                    duration: 3,
                });

                // İşlem tamamlandığında isLoading durumunu sıfırla
                this.setState({ isLoading: false });

                // İptal fonksiyonunu çağırarak modalı kapat
                this.cancelProcess();
            })
            .catch((error) => {
                // Hata durumunda hata mesajını göster
                showAxiosError(error);

                // İşlem tamamlandığında isLoading durumunu sıfırla
                this.setState({ isLoading: false });
            });
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        return (
            <div className='oda-form-container'>
                {this.state.isLoading && (
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                )}
                <div className='card-header'>
                    <h4 className="card-title">
                        {this.props.selectedRequest
                            ? this.props.selectedRequest.description
                            : ""}{" "}
                        Silinecektir
                    </h4>
                </div>
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button
                                type="button"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                style={{ background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
                                rel="tooltip"
                                className="TekBtn vazgec"
                                onClick={this.cancelProcess}
                            >
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8" />
                        <div className='col-sm-2'>
                            <button
                                type="button"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                style={{
                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                    float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                }}
                                rel="tooltip"
                                className="TekBtn kaydet"
                                onClick={() => this.handleDelete(this.props.selectedRequest.id)}
                            >
                                Onayla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TalepDeleteModal;


// WEBPACK FOOTER //
// ./src/page/nobetParams/TalepDeleteModal.js